<template>
<div id ="top">
  <div>
  <ViewSpecies :animal="'mammal'"/>
  </div>
</div>
</template>

<script>
import ViewSpecies from "../components/ViewSpecies.vue"
export default {
  name: 'Mammal',
  components: {
    ViewSpecies,
  }
}
</script>
